const brentford = [
  {
    id: 0,
    pais: "inglaterra",
    liga: "premier-league",
    time: "brentford",
    nome: "Brentford 25/26 - Uniforme 1",
    tipo: "masculino",
    aliases: [
      "brentford",
      "the bees",
      "brentford 2025",
      "2025 brentford",
      "2025",
    ],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/inglaterra/premier-league/brentford/25-26-01/uni0.jpg",
      "/images/inglaterra/premier-league/brentford/25-26-01/uni1.jpg",
      "/images/inglaterra/premier-league/brentford/25-26-01/uni2.jpg",
      "/images/inglaterra/premier-league/brentford/25-26-01/uni3.jpg",
      "/images/inglaterra/premier-league/brentford/25-26-01/uni4.jpg",
    ],
  },
  {
    id: 1,
    pais: "inglaterra",
    liga: "premier-league",
    time: "brentford",
    nome: "Brentford 25/26 - Uniforme 2",
    tipo: "masculino",
    aliases: [
      "brentford",
      "the bees",
      "brentford 2025",
      "2025 brentford",
      "2025",
    ],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/inglaterra/premier-league/brentford/25-26-02/uni0.png",
      "/images/inglaterra/premier-league/brentford/25-26-02/uni1.png",
    ],
  },
  {
    id: 2,
    pais: "inglaterra",
    liga: "premier-league",
    time: "brentford",
    nome: "Brentford 25/26 - Uniforme 3",
    tipo: "masculino",
    aliases: [
      "brentford",
      "the bees",
      "brentford 2025",
      "2025 brentford",
      "2025",
    ],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/inglaterra/premier-league/brentford/25-26-03/uni0.png",
      "/images/inglaterra/premier-league/brentford/25-26-03/uni1.png",
    ],
  },
  {
    id: 3,
    pais: "inglaterra",
    liga: "premier-league",
    time: "brentford",
    nome: "Brentford 24/25 - Uniforme 2",
    tipo: "masculino",
    aliases: [
      "brentford",
      "the bees",
      "brentford 2024",
      "2024 brentford",
      "2024",
    ],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/inglaterra/premier-league/brentford/24-25-02/uni0.png",
      "/images/inglaterra/premier-league/brentford/24-25-02/uni1.png",
    ],
  },
  {
    id: 4,
    pais: "inglaterra",
    liga: "premier-league",
    time: "brentford",
    nome: "Brentford 21/22 - Uniforme 1",
    tipo: "masculino",
    aliases: [
      "brentford",
      "the bees",
      "brentford 2024",
      "2024 brentford",
      "2024",
    ],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/inglaterra/premier-league/brentford/21-22-01/uni0.jpg",
      "/images/inglaterra/premier-league/brentford/21-22-01/uni1.jpg",
      "/images/inglaterra/premier-league/brentford/21-22-01/uni2.jpg",
      "/images/inglaterra/premier-league/brentford/21-22-01/uni3.jpg",
      "/images/inglaterra/premier-league/brentford/21-22-01/uni4.jpg",
    ],
  },
];

export default brentford;
